var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 2.5a3 3 0 0 1 2.995 2.823L17 5.5v1h2a3 3 0 0 1 2.995 2.823L22 9.5v6a3.007 3.007 0 0 1-2.824 2.995L19 18.5v2c0 .747-.774 1.204-1.41.914l-.098-.053-.092-.061-3.733-2.8H11a3 3 0 0 1-2.893-2.203l-1.552 1.035a1 1 0 0 1-1.55-.72L5 16.5v-2a3.003 3.003 0 0 1-2.995-2.824L2 11.5v-6a2.996 2.996 0 0 1 2.824-2.995L5 2.5h9zm5 6h-8a.992.992 0 0 0-.993.882L10 9.5v6a1 1 0 0 0 .883.993L11 16.5h3a1 1 0 0 1 .492.13l.108.07 2.4 1.8v-1a1 1 0 0 1 .77-.974l.113-.02L18 16.5h1c.509 0 .935-.39.993-.884L20 15.5v-6a1 1 0 0 0-1-1zm-1.293 2.293a1 1 0 0 1 .083 1.32l-.083.094-2.5 2.5a1 1 0 0 1-1.32.083l-.094-.083-1.5-1.5a1 1 0 0 1 1.32-1.497l.094.083.793.792 1.793-1.792a1 1 0 0 1 1.414 0zM14 4.5H5a.996.996 0 0 0-.993.883L4 5.5v6c0 .51.387.935.884.993L5 12.5h1a1 1 0 0 1 .993.883L7 13.5v1.13l1-.666V9.5a2.993 2.993 0 0 1 2.823-2.995L11 6.5h4v-1a1 1 0 0 0-.883-.993L14 4.5z",
    fill: "#111827",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsFeedback);
export default __webpack_public_path__ + "static/media/icons-feedback.b6f4b943afbce6bca1a3b3c771837f74.svg";
export { ForwardRef as ReactComponent };